import { render, staticRenderFns } from "./BindsTableToolbar.vue?vue&type=template&id=ff36196c&"
import script from "./BindsTableToolbar.vue?vue&type=script&lang=js&"
export * from "./BindsTableToolbar.vue?vue&type=script&lang=js&"
import style0 from "./BindsTableToolbar.vue?vue&type=style&index=0&id=ff36196c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports